// Full world dial-code list + geo detection.
// Detection is timezone-first (reliable) with locale as fallback, because many
// users (e.g. in the Philippines) run an en-US browser locale.

export const COUNTRIES = [
  { iso: "AF", name: "Afghanistan", dial: "+93" },
  { iso: "AL", name: "Albania", dial: "+355" },
  { iso: "DZ", name: "Algeria", dial: "+213" },
  { iso: "AS", name: "American Samoa", dial: "+1684" },
  { iso: "AD", name: "Andorra", dial: "+376" },
  { iso: "AO", name: "Angola", dial: "+244" },
  { iso: "AI", name: "Anguilla", dial: "+1264" },
  { iso: "AG", name: "Antigua & Barbuda", dial: "+1268" },
  { iso: "AR", name: "Argentina", dial: "+54" },
  { iso: "AM", name: "Armenia", dial: "+374" },
  { iso: "AW", name: "Aruba", dial: "+297" },
  { iso: "AU", name: "Australia", dial: "+61" },
  { iso: "AT", name: "Austria", dial: "+43" },
  { iso: "AZ", name: "Azerbaijan", dial: "+994" },
  { iso: "BS", name: "Bahamas", dial: "+1242" },
  { iso: "BH", name: "Bahrain", dial: "+973" },
  { iso: "BD", name: "Bangladesh", dial: "+880" },
  { iso: "BB", name: "Barbados", dial: "+1246" },
  { iso: "BY", name: "Belarus", dial: "+375" },
  { iso: "BE", name: "Belgium", dial: "+32" },
  { iso: "BZ", name: "Belize", dial: "+501" },
  { iso: "BJ", name: "Benin", dial: "+229" },
  { iso: "BM", name: "Bermuda", dial: "+1441" },
  { iso: "BT", name: "Bhutan", dial: "+975" },
  { iso: "BO", name: "Bolivia", dial: "+591" },
  { iso: "BA", name: "Bosnia & Herzegovina", dial: "+387" },
  { iso: "BW", name: "Botswana", dial: "+267" },
  { iso: "BR", name: "Brazil", dial: "+55" },
  { iso: "BN", name: "Brunei", dial: "+673" },
  { iso: "BG", name: "Bulgaria", dial: "+359" },
  { iso: "BF", name: "Burkina Faso", dial: "+226" },
  { iso: "BI", name: "Burundi", dial: "+257" },
  { iso: "KH", name: "Cambodia", dial: "+855" },
  { iso: "CM", name: "Cameroon", dial: "+237" },
  { iso: "CA", name: "Canada", dial: "+1" },
  { iso: "CV", name: "Cape Verde", dial: "+238" },
  { iso: "KY", name: "Cayman Islands", dial: "+1345" },
  { iso: "CF", name: "Central African Republic", dial: "+236" },
  { iso: "TD", name: "Chad", dial: "+235" },
  { iso: "CL", name: "Chile", dial: "+56" },
  { iso: "CN", name: "China", dial: "+86" },
  { iso: "CO", name: "Colombia", dial: "+57" },
  { iso: "KM", name: "Comoros", dial: "+269" },
  { iso: "CG", name: "Congo", dial: "+242" },
  { iso: "CD", name: "Congo (DRC)", dial: "+243" },
  { iso: "CK", name: "Cook Islands", dial: "+682" },
  { iso: "CR", name: "Costa Rica", dial: "+506" },
  { iso: "CI", name: "Côte d'Ivoire", dial: "+225" },
  { iso: "HR", name: "Croatia", dial: "+385" },
  { iso: "CU", name: "Cuba", dial: "+53" },
  { iso: "CW", name: "Curaçao", dial: "+599" },
  { iso: "CY", name: "Cyprus", dial: "+357" },
  { iso: "CZ", name: "Czechia", dial: "+420" },
  { iso: "DK", name: "Denmark", dial: "+45" },
  { iso: "DJ", name: "Djibouti", dial: "+253" },
  { iso: "DM", name: "Dominica", dial: "+1767" },
  { iso: "DO", name: "Dominican Republic", dial: "+1809" },
  { iso: "EC", name: "Ecuador", dial: "+593" },
  { iso: "EG", name: "Egypt", dial: "+20" },
  { iso: "SV", name: "El Salvador", dial: "+503" },
  { iso: "GQ", name: "Equatorial Guinea", dial: "+240" },
  { iso: "ER", name: "Eritrea", dial: "+291" },
  { iso: "EE", name: "Estonia", dial: "+372" },
  { iso: "SZ", name: "Eswatini", dial: "+268" },
  { iso: "ET", name: "Ethiopia", dial: "+251" },
  { iso: "FJ", name: "Fiji", dial: "+679" },
  { iso: "FI", name: "Finland", dial: "+358" },
  { iso: "FR", name: "France", dial: "+33" },
  { iso: "GF", name: "French Guiana", dial: "+594" },
  { iso: "PF", name: "French Polynesia", dial: "+689" },
  { iso: "GA", name: "Gabon", dial: "+241" },
  { iso: "GM", name: "Gambia", dial: "+220" },
  { iso: "GE", name: "Georgia", dial: "+995" },
  { iso: "DE", name: "Germany", dial: "+49" },
  { iso: "GH", name: "Ghana", dial: "+233" },
  { iso: "GI", name: "Gibraltar", dial: "+350" },
  { iso: "GR", name: "Greece", dial: "+30" },
  { iso: "GL", name: "Greenland", dial: "+299" },
  { iso: "GD", name: "Grenada", dial: "+1473" },
  { iso: "GP", name: "Guadeloupe", dial: "+590" },
  { iso: "GU", name: "Guam", dial: "+1671" },
  { iso: "GT", name: "Guatemala", dial: "+502" },
  { iso: "GN", name: "Guinea", dial: "+224" },
  { iso: "GW", name: "Guinea-Bissau", dial: "+245" },
  { iso: "GY", name: "Guyana", dial: "+592" },
  { iso: "HT", name: "Haiti", dial: "+509" },
  { iso: "HN", name: "Honduras", dial: "+504" },
  { iso: "HK", name: "Hong Kong", dial: "+852" },
  { iso: "HU", name: "Hungary", dial: "+36" },
  { iso: "IS", name: "Iceland", dial: "+354" },
  { iso: "IN", name: "India", dial: "+91" },
  { iso: "ID", name: "Indonesia", dial: "+62" },
  { iso: "IR", name: "Iran", dial: "+98" },
  { iso: "IQ", name: "Iraq", dial: "+964" },
  { iso: "IE", name: "Ireland", dial: "+353" },
  { iso: "IL", name: "Israel", dial: "+972" },
  { iso: "IT", name: "Italy", dial: "+39" },
  { iso: "JM", name: "Jamaica", dial: "+1876" },
  { iso: "JP", name: "Japan", dial: "+81" },
  { iso: "JO", name: "Jordan", dial: "+962" },
  { iso: "KZ", name: "Kazakhstan", dial: "+7" },
  { iso: "KE", name: "Kenya", dial: "+254" },
  { iso: "KI", name: "Kiribati", dial: "+686" },
  { iso: "KW", name: "Kuwait", dial: "+965" },
  { iso: "KG", name: "Kyrgyzstan", dial: "+996" },
  { iso: "LA", name: "Laos", dial: "+856" },
  { iso: "LV", name: "Latvia", dial: "+371" },
  { iso: "LB", name: "Lebanon", dial: "+961" },
  { iso: "LS", name: "Lesotho", dial: "+266" },
  { iso: "LR", name: "Liberia", dial: "+231" },
  { iso: "LY", name: "Libya", dial: "+218" },
  { iso: "LI", name: "Liechtenstein", dial: "+423" },
  { iso: "LT", name: "Lithuania", dial: "+370" },
  { iso: "LU", name: "Luxembourg", dial: "+352" },
  { iso: "MO", name: "Macau", dial: "+853" },
  { iso: "MG", name: "Madagascar", dial: "+261" },
  { iso: "MW", name: "Malawi", dial: "+265" },
  { iso: "MY", name: "Malaysia", dial: "+60" },
  { iso: "MV", name: "Maldives", dial: "+960" },
  { iso: "ML", name: "Mali", dial: "+223" },
  { iso: "MT", name: "Malta", dial: "+356" },
  { iso: "MH", name: "Marshall Islands", dial: "+692" },
  { iso: "MQ", name: "Martinique", dial: "+596" },
  { iso: "MR", name: "Mauritania", dial: "+222" },
  { iso: "MU", name: "Mauritius", dial: "+230" },
  { iso: "MX", name: "Mexico", dial: "+52" },
  { iso: "FM", name: "Micronesia", dial: "+691" },
  { iso: "MD", name: "Moldova", dial: "+373" },
  { iso: "MC", name: "Monaco", dial: "+377" },
  { iso: "MN", name: "Mongolia", dial: "+976" },
  { iso: "ME", name: "Montenegro", dial: "+382" },
  { iso: "MS", name: "Montserrat", dial: "+1664" },
  { iso: "MA", name: "Morocco", dial: "+212" },
  { iso: "MZ", name: "Mozambique", dial: "+258" },
  { iso: "MM", name: "Myanmar", dial: "+95" },
  { iso: "NA", name: "Namibia", dial: "+264" },
  { iso: "NR", name: "Nauru", dial: "+674" },
  { iso: "NP", name: "Nepal", dial: "+977" },
  { iso: "NL", name: "Netherlands", dial: "+31" },
  { iso: "NC", name: "New Caledonia", dial: "+687" },
  { iso: "NZ", name: "New Zealand", dial: "+64" },
  { iso: "NI", name: "Nicaragua", dial: "+505" },
  { iso: "NE", name: "Niger", dial: "+227" },
  { iso: "NG", name: "Nigeria", dial: "+234" },
  { iso: "KP", name: "North Korea", dial: "+850" },
  { iso: "MK", name: "North Macedonia", dial: "+389" },
  { iso: "NO", name: "Norway", dial: "+47" },
  { iso: "OM", name: "Oman", dial: "+968" },
  { iso: "PK", name: "Pakistan", dial: "+92" },
  { iso: "PW", name: "Palau", dial: "+680" },
  { iso: "PS", name: "Palestine", dial: "+970" },
  { iso: "PA", name: "Panama", dial: "+507" },
  { iso: "PG", name: "Papua New Guinea", dial: "+675" },
  { iso: "PY", name: "Paraguay", dial: "+595" },
  { iso: "PE", name: "Peru", dial: "+51" },
  { iso: "PH", name: "Philippines", dial: "+63" },
  { iso: "PL", name: "Poland", dial: "+48" },
  { iso: "PT", name: "Portugal", dial: "+351" },
  { iso: "PR", name: "Puerto Rico", dial: "+1787" },
  { iso: "QA", name: "Qatar", dial: "+974" },
  { iso: "RE", name: "Réunion", dial: "+262" },
  { iso: "RO", name: "Romania", dial: "+40" },
  { iso: "RU", name: "Russia", dial: "+7" },
  { iso: "RW", name: "Rwanda", dial: "+250" },
  { iso: "WS", name: "Samoa", dial: "+685" },
  { iso: "SM", name: "San Marino", dial: "+378" },
  { iso: "ST", name: "São Tomé & Príncipe", dial: "+239" },
  { iso: "SA", name: "Saudi Arabia", dial: "+966" },
  { iso: "SN", name: "Senegal", dial: "+221" },
  { iso: "RS", name: "Serbia", dial: "+381" },
  { iso: "SC", name: "Seychelles", dial: "+248" },
  { iso: "SL", name: "Sierra Leone", dial: "+232" },
  { iso: "SG", name: "Singapore", dial: "+65" },
  { iso: "SK", name: "Slovakia", dial: "+421" },
  { iso: "SI", name: "Slovenia", dial: "+386" },
  { iso: "SB", name: "Solomon Islands", dial: "+677" },
  { iso: "SO", name: "Somalia", dial: "+252" },
  { iso: "ZA", name: "South Africa", dial: "+27" },
  { iso: "KR", name: "South Korea", dial: "+82" },
  { iso: "SS", name: "South Sudan", dial: "+211" },
  { iso: "ES", name: "Spain", dial: "+34" },
  { iso: "LK", name: "Sri Lanka", dial: "+94" },
  { iso: "SD", name: "Sudan", dial: "+249" },
  { iso: "SR", name: "Suriname", dial: "+597" },
  { iso: "SE", name: "Sweden", dial: "+46" },
  { iso: "CH", name: "Switzerland", dial: "+41" },
  { iso: "SY", name: "Syria", dial: "+963" },
  { iso: "TW", name: "Taiwan", dial: "+886" },
  { iso: "TJ", name: "Tajikistan", dial: "+992" },
  { iso: "TZ", name: "Tanzania", dial: "+255" },
  { iso: "TH", name: "Thailand", dial: "+66" },
  { iso: "TL", name: "Timor-Leste", dial: "+670" },
  { iso: "TG", name: "Togo", dial: "+228" },
  { iso: "TO", name: "Tonga", dial: "+676" },
  { iso: "TT", name: "Trinidad & Tobago", dial: "+1868" },
  { iso: "TN", name: "Tunisia", dial: "+216" },
  { iso: "TR", name: "Turkey", dial: "+90" },
  { iso: "TM", name: "Turkmenistan", dial: "+993" },
  { iso: "UG", name: "Uganda", dial: "+256" },
  { iso: "UA", name: "Ukraine", dial: "+380" },
  { iso: "AE", name: "United Arab Emirates", dial: "+971" },
  { iso: "GB", name: "United Kingdom", dial: "+44" },
  { iso: "US", name: "United States", dial: "+1" },
  { iso: "UY", name: "Uruguay", dial: "+598" },
  { iso: "UZ", name: "Uzbekistan", dial: "+998" },
  { iso: "VU", name: "Vanuatu", dial: "+678" },
  { iso: "VE", name: "Venezuela", dial: "+58" },
  { iso: "VN", name: "Vietnam", dial: "+84" },
  { iso: "YE", name: "Yemen", dial: "+967" },
  { iso: "ZM", name: "Zambia", dial: "+260" },
  { iso: "ZW", name: "Zimbabwe", dial: "+263" },
];

// IANA timezone -> ISO country (timezone is the most reliable geo signal).
const TZ_TO_ISO = {
  "Asia/Manila": "PH", "Asia/Singapore": "SG", "Asia/Hong_Kong": "HK", "Asia/Macau": "MO",
  "Asia/Tokyo": "JP", "Asia/Seoul": "KR", "Asia/Taipei": "TW", "Asia/Shanghai": "CN",
  "Asia/Bangkok": "TH", "Asia/Jakarta": "ID", "Asia/Makassar": "ID", "Asia/Jayapura": "ID",
  "Asia/Kuala_Lumpur": "MY", "Asia/Kuching": "MY", "Asia/Ho_Chi_Minh": "VN", "Asia/Saigon": "VN",
  "Asia/Phnom_Penh": "KH", "Asia/Vientiane": "LA", "Asia/Yangon": "MM", "Asia/Rangoon": "MM",
  "Asia/Brunei": "BN", "Asia/Dili": "TL", "Asia/Dhaka": "BD", "Asia/Thimphu": "BT",
  "Asia/Kathmandu": "NP", "Asia/Colombo": "LK", "Asia/Karachi": "PK", "Asia/Kabul": "AF",
  "Asia/Kolkata": "IN", "Asia/Calcutta": "IN", "Asia/Mumbai": "IN", "Asia/Delhi": "IN",
  "Asia/Dubai": "AE", "Asia/Muscat": "OM", "Asia/Qatar": "QA", "Asia/Bahrain": "BH",
  "Asia/Kuwait": "KW", "Asia/Riyadh": "SA", "Asia/Baghdad": "IQ", "Asia/Tehran": "IR",
  "Asia/Jerusalem": "IL", "Asia/Tel_Aviv": "IL", "Asia/Amman": "JO", "Asia/Beirut": "LB",
  "Asia/Damascus": "SY", "Asia/Nicosia": "CY", "Asia/Baku": "AZ", "Asia/Yerevan": "AM",
  "Asia/Tbilisi": "GE", "Asia/Almaty": "KZ", "Asia/Tashkent": "UZ", "Asia/Samarkand": "UZ",
  "Asia/Ashgabat": "TM", "Asia/Dushanbe": "TJ", "Asia/Bishkek": "KG", "Asia/Ulaanbaatar": "MN",
  "Asia/Istanbul": "TR", "Europe/Istanbul": "TR",
  "Europe/London": "GB", "Europe/Dublin": "IE", "Europe/Paris": "FR", "Europe/Berlin": "DE",
  "Europe/Madrid": "ES", "Europe/Rome": "IT", "Europe/Amsterdam": "NL", "Europe/Brussels": "BE",
  "Europe/Vienna": "AT", "Europe/Zurich": "CH", "Europe/Stockholm": "SE", "Europe/Oslo": "NO",
  "Europe/Copenhagen": "DK", "Europe/Helsinki": "FI", "Europe/Warsaw": "PL", "Europe/Prague": "CZ",
  "Europe/Budapest": "HU", "Europe/Bucharest": "RO", "Europe/Sofia": "BG", "Europe/Athens": "GR",
  "Europe/Lisbon": "PT", "Europe/Moscow": "RU", "Europe/Kiev": "UA", "Europe/Kyiv": "UA",
  "Europe/Minsk": "BY", "Europe/Riga": "LV", "Europe/Vilnius": "LT", "Europe/Tallinn": "EE",
  "Europe/Belgrade": "RS", "Europe/Zagreb": "HR", "Europe/Ljubljana": "SI", "Europe/Bratislava": "SK",
  "Europe/Sarajevo": "BA", "Europe/Podgorica": "ME", "Europe/Skopje": "MK", "Europe/Tirane": "AL",
  "Europe/Malta": "MT", "Europe/Luxembourg": "LU", "Europe/Monaco": "MC", "Europe/Reykjavik": "IS",
  "Europe/Chisinau": "MD", "Europe/Gibraltar": "GI", "Europe/Vaduz": "LI", "Europe/San_Marino": "SM",
  "America/New_York": "US", "America/Chicago": "US", "America/Denver": "US", "America/Phoenix": "US",
  "America/Los_Angeles": "US", "America/Anchorage": "US", "America/Adak": "US", "Pacific/Honolulu": "US",
  "America/Detroit": "US", "America/Indiana/Indianapolis": "US", "America/Boise": "US",
  "America/Toronto": "CA", "America/Vancouver": "CA", "America/Winnipeg": "CA", "America/Halifax": "CA",
  "America/Montreal": "CA", "America/Edmonton": "CA", "America/St_Johns": "CA", "America/Regina": "CA",
  "America/Mexico_City": "MX", "America/Tijuana": "MX", "America/Cancun": "MX", "America/Monterrey": "MX",
  "America/Guatemala": "GT", "America/Belize": "BZ", "America/Tegucigalpa": "HN", "America/Managua": "NI",
  "America/Costa_Rica": "CR", "America/Panama": "PA", "America/El_Salvador": "SV",
  "America/Havana": "CU", "America/Jamaica": "JM", "America/Port-au-Prince": "HT",
  "America/Santo_Domingo": "DO", "America/Puerto_Rico": "PR", "America/Nassau": "BS",
  "America/Barbados": "BB", "America/Port_of_Spain": "TT", "America/Grenada": "GD",
  "America/Bogota": "CO", "America/Lima": "PE", "America/Guayaquil": "EC", "America/Caracas": "VE",
  "America/Guyana": "GY", "America/Paramaribo": "SR", "America/Cayenne": "GF",
  "America/Santiago": "CL", "America/Sao_Paulo": "BR", "America/Rio_Branco": "BR", "America/Manaus": "BR",
  "America/Argentina/Buenos_Aires": "AR", "America/Montevideo": "UY", "America/Asuncion": "PY",
  "America/La_Paz": "BO",
  "Australia/Sydney": "AU", "Australia/Melbourne": "AU", "Australia/Brisbane": "AU",
  "Australia/Perth": "AU", "Australia/Adelaide": "AU", "Australia/Darwin": "AU", "Australia/Hobart": "AU",
  "Pacific/Auckland": "NZ", "Pacific/Fiji": "FJ", "Pacific/Guam": "GU", "Pacific/Port_Moresby": "PG",
  "Pacific/Noumea": "NC", "Pacific/Tahiti": "PF", "Pacific/Tongatapu": "TO", "Pacific/Apia": "WS",
  "Pacific/Palau": "PW", "Pacific/Majuro": "MH", "Pacific/Pohnpei": "FM", "Pacific/Nauru": "NR",
  "Pacific/Tarawa": "KI", "Pacific/Efate": "VU", "Pacific/Guadalcanal": "SB", "Pacific/Saipan": "US",
  "Africa/Cairo": "EG", "Africa/Lagos": "NG", "Africa/Nairobi": "KE", "Africa/Johannesburg": "ZA",
  "Africa/Accra": "GH", "Africa/Casablanca": "MA", "Africa/Algiers": "DZ", "Africa/Tunis": "TN",
  "Africa/Tripoli": "LY", "Africa/Khartoum": "SD", "Africa/Addis_Ababa": "ET", "Africa/Dar_es_Salaam": "TZ",
  "Africa/Kampala": "UG", "Africa/Kigali": "RW", "Africa/Lusaka": "ZM", "Africa/Harare": "ZW",
  "Africa/Maputo": "MZ", "Africa/Windhoek": "NA", "Africa/Gaborone": "BW", "Africa/Dakar": "SN",
  "Africa/Abidjan": "CI", "Africa/Douala": "CM", "Africa/Kinshasa": "CD", "Africa/Luanda": "AO",
  "Africa/Bamako": "ML", "Africa/Ouagadougou": "BF", "Africa/Niamey": "NE", "Africa/Ndjamena": "TD",
  "Africa/Mogadishu": "SO", "Africa/Djibouti": "DJ", "Africa/Asmara": "ER", "Africa/Juba": "SS",
  "Africa/Maseru": "LS", "Africa/Mbabane": "SZ", "Africa/Monrovia": "LR", "Africa/Freetown": "SL",
  "Africa/Conakry": "GN", "Africa/Bissau": "GW", "Africa/Banjul": "GM", "Africa/Nouakchott": "MR",
  "Africa/Lome": "TG", "Africa/Porto-Novo": "BJ", "Africa/Libreville": "GA", "Africa/Brazzaville": "CG",
  "Africa/Bangui": "CF", "Africa/Malabo": "GQ", "Africa/Sao_Tome": "ST", "Africa/Mauritius": "MU",
  "Indian/Mauritius": "MU", "Indian/Reunion": "RE", "Indian/Maldives": "MV", "Indian/Seychelles": "SC",
};

// Best-effort visitor country ISO ("PH", "US", ...), "" if unknown.
// Timezone first (locale is often en-US even for non-US users), locale second.
export const detectCountry = () => {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
    if (TZ_TO_ISO[tz]) return TZ_TO_ISO[tz];
  } catch (e) { /* ignore */ }
  try {
    const loc = Intl.DateTimeFormat().resolvedOptions().locale || navigator.language || "";
    const m = loc.match(/-([A-Za-z]{2})\b/);
    if (m && COUNTRIES.some((c) => c.iso === m[1].toUpperCase())) return m[1].toUpperCase();
  } catch (e) { /* ignore */ }
  return "";
};

export const dialFor = (iso) => COUNTRIES.find((c) => c.iso === iso)?.dial || "";

// Curated primary time zones (one per country) for the admin's travel override.
export const TZ_OPTIONS = [
  { iso: "PH", tz: "Asia/Manila" }, { iso: "SG", tz: "Asia/Singapore" }, { iso: "JP", tz: "Asia/Tokyo" },
  { iso: "KR", tz: "Asia/Seoul" }, { iso: "HK", tz: "Asia/Hong_Kong" }, { iso: "TW", tz: "Asia/Taipei" },
  { iso: "CN", tz: "Asia/Shanghai" }, { iso: "TH", tz: "Asia/Bangkok" }, { iso: "VN", tz: "Asia/Ho_Chi_Minh" },
  { iso: "ID", tz: "Asia/Jakarta" }, { iso: "MY", tz: "Asia/Kuala_Lumpur" }, { iso: "KH", tz: "Asia/Phnom_Penh" },
  { iso: "MM", tz: "Asia/Yangon" }, { iso: "IN", tz: "Asia/Kolkata" }, { iso: "LK", tz: "Asia/Colombo" },
  { iso: "NP", tz: "Asia/Kathmandu" }, { iso: "PK", tz: "Asia/Karachi" }, { iso: "BD", tz: "Asia/Dhaka" },
  { iso: "AE", tz: "Asia/Dubai" }, { iso: "QA", tz: "Asia/Qatar" }, { iso: "SA", tz: "Asia/Riyadh" },
  { iso: "IL", tz: "Asia/Jerusalem" }, { iso: "TR", tz: "Asia/Istanbul" },
  { iso: "AU", tz: "Australia/Sydney" }, { iso: "NZ", tz: "Pacific/Auckland" }, { iso: "FJ", tz: "Pacific/Fiji" },
  { iso: "GB", tz: "Europe/London" }, { iso: "IE", tz: "Europe/Dublin" }, { iso: "FR", tz: "Europe/Paris" },
  { iso: "DE", tz: "Europe/Berlin" }, { iso: "NL", tz: "Europe/Amsterdam" }, { iso: "ES", tz: "Europe/Madrid" },
  { iso: "IT", tz: "Europe/Rome" }, { iso: "PT", tz: "Europe/Lisbon" }, { iso: "CH", tz: "Europe/Zurich" },
  { iso: "AT", tz: "Europe/Vienna" }, { iso: "BE", tz: "Europe/Brussels" }, { iso: "SE", tz: "Europe/Stockholm" },
  { iso: "NO", tz: "Europe/Oslo" }, { iso: "DK", tz: "Europe/Copenhagen" }, { iso: "FI", tz: "Europe/Helsinki" },
  { iso: "GR", tz: "Europe/Athens" }, { iso: "CZ", tz: "Europe/Prague" }, { iso: "PL", tz: "Europe/Warsaw" },
  { iso: "RU", tz: "Europe/Moscow" }, { iso: "UA", tz: "Europe/Kyiv" },
  { iso: "US", tz: "America/New_York" }, { iso: "US-C", tz: "America/Chicago", name: "United States (Central)" },
  { iso: "US-M", tz: "America/Denver", name: "United States (Mountain)" },
  { iso: "US-P", tz: "America/Los_Angeles", name: "United States (Pacific)" },
  { iso: "US-H", tz: "Pacific/Honolulu", name: "United States (Hawaii)" },
  { iso: "CA", tz: "America/Toronto" }, { iso: "MX", tz: "America/Mexico_City" },
  { iso: "BR", tz: "America/Sao_Paulo" }, { iso: "AR", tz: "America/Argentina/Buenos_Aires" },
  { iso: "EG", tz: "Africa/Cairo" }, { iso: "ZA", tz: "Africa/Johannesburg" }, { iso: "KE", tz: "Africa/Nairobi" },
].map((o) => ({
  ...o,
  name: o.name || COUNTRIES.find((c) => c.iso === o.iso)?.name || o.iso,
}));

// GMT offset label for a zone, e.g. "GMT+8" (runtime-computed, handles DST).
export const tzOffsetLabel = (tz) => {
  try {
    const part = new Intl.DateTimeFormat("en-US", { timeZone: tz, timeZoneName: "shortOffset" })
      .formatToParts(new Date()).find((p) => p.type === "timeZoneName");
    return part?.value || tz;
  } catch (e) {
    return tz;
  }
};
